module.exports = __webpack_public_path__ + "static/media/voucher-category-car.c7dbcdf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/voucher-category-car.svg
// module id = 943
// module chunks = 0